import { FieldOkStore } from "@softline/dynamic";
import {Entity} from '@softline/core';

export const KundenanlageFieldOkStore = FieldOkStore.create<object & Entity>()
